export function stringExpressionReplacement(str, memory){
    if(!str || str.trim() ==="")
        return str;

    let replace = [];

    let loading = false;
    let tmpObj = {};
    let tmpIndex = -1;
    for(let i=0;i<str.length;i++){
        if(loading && str[i] !== "%"){
            tmpObj.exp = tmpObj.exp+str[i];
            tmpObj.value = tmpObj.value+str[i];
        }

        if(str[i] === "%"){
            if(loading){
                loading = false;
                tmpObj.end = i;
                tmpObj.value = tmpObj.value+"%";
                replace.push({...tmpObj});
            }else{
                tmpIndex++;
                tmpObj = {};
                tmpObj.value = "%";
                tmpObj.exp = "";
                tmpObj.start =i;
                loading = true;
            }
        }
    }

    for(let i=0;i<replace.length;i++){
        let reg = new RegExp(replace[i].value,"g");
        if(memory.hasOwnProperty(replace[i].exp)){
            str = str.replace(reg, memory[replace[i].exp])
        }else{
            str = str.replace(reg, "")
        }
    }
    return str;
}